<template src="./CartSidebar.html"></template>
<style lang="scss" scoped src="./CartSidebar.scss"></style>

<script>
import {
    SfBar,
    SfSidebar,
    SfHeading,
    SfButton,
    SfIcon,
    SfProperty,
    SfPrice,
    SfCircleIcon,
    SfCollectedProduct,
    SfImage,
    SfLink,
    SfDivider
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkPrice from "@/components/Ork/OrkPrice";
import GtagEvent from "@/utils/GtagEvent";


export default {
    name: 'Cart',
    components: {
        SfBar,
        SfDivider,
        OrkPrice,
        SfSidebar,
        SfCircleIcon,
        SfLink,
        SfButton,
        SfHeading,
        SfIcon,
        SfProperty,
        SfPrice,
        SfCollectedProduct,
        SfImage
    },
    data() {
        return {
            loading: {
                cart: null,
            },
            icons: icons,
            totalItems: 0,
            isLogin: true,
        }
    },

    computed: {
        isCartSidebarOpen: {
            get() {
                if (this.currentCart && this.$store.getters.isCartSidebarOpen) {
                    GtagEvent.viewCart(this.currentCart)
                }
                return this.$store.getters.isCartSidebarOpen
            }
        },
        currentCart: {
            get() {
                return this.$store.getters.getCart
            },
            set() {
            }
        },
    },

    methods: {
        clearCart() {
            Api.cart.emptyCart(this.currentCart.id).then((data) => {
                this.$store.dispatch('setCart', data)
            }).catch((e) => {
                this.$store.dispatch('setCart', null);
                this.currentCart = null;
            })
        },
        backToHome() {
            this.toggleCartSidebar()
        },
        toggleCartSidebar() {
            this.$store.dispatch('toggleCartSidebar')
        },
        openProduct(link) {
            this.toggleCartSidebar()
            this.$router.push(this.$localizePath(link))
        },
        removeCoupon() {
            Api.cart.removeCoupon()
                .then((data) => {
                    this.$store.dispatch('setCart', data);
                    this.$store.dispatch('sendNotification', {
                        type: 'info',
                        message: this.$i18n.t('coupon.add'),
                        icon: icons.info
                    });
                })
                .catch((e) => {
                    switch (e.status) {
                        case 409:
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('coupon.allready'),
                                icon: icons.error
                            });
                            break;
                        case 404:
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('coupon.not'),
                                icon: icons.error
                            });
                            break;
                        default:
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('errors.server.access'),
                                icon: icons.error
                            });
                            break
                    }

                })
                .finally();

        },
        setOfferQuantity(params) {
            this.loading = true;

            let cart = params.currentCart,
                itemIsInCart = null,
                qty = params.quantity,
                prevQty = 0,
                stock = 0;

            if (cart && cart.cartItems && cart.cartItems.length) {
                itemIsInCart = cart.cartItems.find(item => item.product?.offer?.id === params.offerId);

                if (itemIsInCart) {
                    prevQty = itemIsInCart?.quantity || 0;
                    stock = itemIsInCart?.product.offer.stockQuantity || 0;
                }
            }
            if (qty > stock) {
                this.$store.dispatch('sendNotification', {
                    type: 'info',
                    message: this.$i18n.t("addToCart.max"),
                    icon: icons.info
                });

            } else {
                Api.cart.setOfferQuantity(params)
                    .then(data => {
                        this.$store.dispatch('setCart', data);
                        this.currentCart = data;

                        let message = '';
                        switch (params.method) {
                            case'add':
                                GtagEvent.AddToCartShipment(params.product, qty, this.currentCart)
                                message = this.$i18n.t('addToCart.add');
                                break;
                            case'remove':
                                GtagEvent.RemoveToCart(params.product, this.currentCart)
                                message = this.$i18n.t('addToCart.remove');
                                break;
                            case 'update':
                                GtagEvent.AddToCartShipment(params.product, qty, this.currentCart)
                                message = this.$i18n.t('addToCart.update');
                                break;
                        }
                        this.$store.dispatch('sendNotification', {
                            type: 'info',
                            message: message,
                            icon: icons.info

                        });
                    })
                    .catch((e) => {
                        console.error(e)
                        if (e.status !== 499) {
                            /*this.$store.dispatch('setCart', null);
                          this.currentCart = null;*/
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('errors.server.access'),
                                icon: icons.error
                            });
                            this.error = e;
                        }
                    })
                    .finally(this.loading = false);
            }
        },
        goCart() {
            this.toggleCartSidebar();
            if (this.$route.name !== 'Cart') {
                this.$router.push(this.$localizePath('/mon-panier'));
            }
        },
        goToCheckout() {
            this.toggleCartSidebar();
            this.$router.push(this.$localizePath('/commande/livraison'));
        },
    },
}
</script>